import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { PopupService } from '../../../shared/modal/popup.service';
import { HttpResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { GermplasmNameContext } from '../../../entities/germplasm/name/germplasm-name.context';
import { finalize } from 'rxjs/operators';
import { GermplasmAuditService } from '../germplasm-audit.service';
import { GermplasmNameAudit } from './germplasm-name-audit.model';
import { getEventDate, getEventUser } from '../germplasm-audit-utils';
import { GermplasmDetailsPopupService } from '../../germplasm-details-popup.service';
import { GermplasmDetailsContext } from '../../germplasm-details.context';
import { AlertService } from '../../../shared/alert/alert.service';
import { MAX_NAME_DISPLAY_SIZE } from '../../../app.constants';

@Component({
    selector: 'jhi-germplasm-name-audit',
    templateUrl: './germplasm-name-audit.component.html',
    styleUrls: [
        '../germplasm-audit.scss'
    ]
})
export class GermplasmNameAuditComponent implements OnInit, OnDestroy {

    readonly itemsPerPage: number = 10;
    MAX_NAME_DISPLAY_SIZE = MAX_NAME_DISPLAY_SIZE;

    gid: number;
    nameId: number;
    title: string;

    page: number;
    previousPage: number;
    totalItems: number;
    queryCount: number;
    isLoading: boolean;

    auditChanges: GermplasmNameAudit[];

    getEventDate = getEventDate;
    getEventUser = getEventUser;

    constructor(public activeModal: NgbActiveModal,
                private germplasmAuditService: GermplasmAuditService,
                private translateService: TranslateService,
                private germplasmNameContext: GermplasmNameContext,
                private alertService: AlertService,
                private activatedRoute: ActivatedRoute,
                private router: Router) {
        this.page = 1;

        this.title = this.translateService.instant('audit.title',
            { param1: this.translateService.instant('audit.entities.name'), param2: this.germplasmNameContext.germplasmName.name });
    }

    ngOnInit(): void {
        this.loadAll();
    }

    loadPage(page: number) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    }

    transition() {
        this.router.navigate(['germplasm/:gid/name/:nameId/audit-dialog'], {
            queryParams:
                {
                    page: this.page,
                    size: this.itemsPerPage
                },
            relativeTo: this.activatedRoute,
            queryParamsHandling: 'merge'
        });
        this.loadAll();
    }

    dismiss() {
        this.activeModal.dismiss('cancel');
    }

    private loadAll() {
        this.isLoading = true;
        this.germplasmAuditService.getNameChanges(this.gid, this.nameId, {
            page: this.page - 1,
            size: this.itemsPerPage
        }).pipe(finalize(() => {
            this.isLoading = false;
        })).subscribe(
            (res: HttpResponse<GermplasmNameAudit[]>) => this.onSuccess(res.body, res.headers)
        );
    }

    private onSuccess(data: GermplasmNameAudit[], headers) {
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        this.auditChanges = data;
    }

    ngOnDestroy(): void {
        this.germplasmNameContext.germplasmName = null;
    }
}

@Component({
    selector: 'jhi-germplasm-name-audit-popup',
    template: ''
})
export class GermplasmNameAuditPopupComponent implements OnInit {

    constructor(private route: ActivatedRoute,
                private popupService: PopupService,
                private germplasmDetailsContext: GermplasmDetailsContext,
                private germplasmDetailsPopupService: GermplasmDetailsPopupService) {
    }

    ngOnInit(): void {

        const gid = Number(this.route.snapshot.paramMap.get('gid'));
        const nameId = Number(this.route.snapshot.paramMap.get('nameId'));

        if (this.germplasmDetailsContext.openedFromWorkbench) {
            this.germplasmDetailsPopupService.close();
        }

        const modal = this.popupService.open(GermplasmNameAuditComponent as Component, { modalDialogClass: 'modal-lg', backdrop: 'static' });
        modal.then((modalRef) => {
            modalRef.componentInstance.gid = gid;
            modalRef.componentInstance.nameId = nameId;

            if (this.germplasmDetailsContext.openedFromWorkbench) {
                modalRef.result.then((result) => {
                    this.germplasmDetailsPopupService.open(gid, 'germplasm-basic-details');
                }, () => {
                    this.germplasmDetailsPopupService.open(gid, 'germplasm-basic-details');
                });
            }
        });

    }

}
